import React from "react";

// Build the promo message with the tailor's referral code + the live app link.
export function buildAppShareMessage(tailleur) {
  const code = tailleur?.referral_code;
  const origin = typeof window !== "undefined" ? window.location.origin : "https://taillecouture.com";
  const link = code ? `${origin}/bienvenue?ref=${code}` : origin;
  const lines = [
    "🧵 *TAILLEUR PRO* — le carnet de mesures du tailleur moderne 📱",
    "",
    "Enregistre tes clients, leurs mesures et leurs tissus. Retrouve tout en 2 secondes, même sans internet !",
    "",
    "📏 Mesures • 📸 Photos tissus • 💬 Partage WhatsApp • 📴 Hors ligne",
  ];
  if (code) {
    lines.push("");
    lines.push(`🎁 Utilise mon code *${code}* à l'inscription et reçois *+5 clients gratuits* !`);
  }
  lines.push("");
  lines.push(`📲 Télécharge ici 👉 ${link}`);
  return lines.join("\n");
}

export function shareAppOnWhatsApp(tailleur) {
  const msg = buildAppShareMessage(tailleur);
  window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
}
